export default __webpack_public_path__ + "static/media/SilverTokenSmall.c6105339.png";